import { Button, Menu, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { AddNewNode, NodeList } from '../ManageNodes';
import AddUser from '../AddUser';
import UserList from '../UserList';
import AddTemplateOodocs from '../AddTemplateOodocs';
import TemplateListOodocs from '../TemplateListOodocs';
import AddCenter from '../AddCenter';
import CenterList from '../CenterList';
import StatsDashboard from '../StatsDashboard';
import CenterAnalytics from '../CenterAnalytics';
import ReportHeaderConfig from './ReportHeaderConfig';
import ShortcutsAdmin from '../ShortcutsAdmin';
import SessionManagement from '../SessionManagement';
import PricingList from '../PricingList';
import AddPricing from '../AddPricing';
import CostReports from '../CostReports';
import AcademicsPage from '../academics';
import ModalityMaster from '../MastersConfig/ModalityMaster';
import ModalityGroups from '../MastersConfig/ModalityGroups';
import ItemCodes from '../MastersConfig/ItemCodes';
import BodyPartsMaster from '../MastersConfig/BodyPartsMaster';
import ModalityLocations from '../MastersConfig/ModalityLocations';
import Hl7ForwardRoutes from '../MastersConfig/Hl7ForwardRoutes';
import ManageStudies from '../ManageStudies';
import ReferralPhysicians from '../MastersConfig/ReferralPhysicians';
import IntegrationLogs from '../IntegrationLogs';
import { NavigationItems } from './constants';
import './settings.css';

const Settings = ({userType}) => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState();

  useEffect(() => {
    setSelectedMenu(userType === 'support_admin' ? 'users_list' : 'analytics_dashboard');
  }, []);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const onNavChange = (item) => {
    console.log('onNavChange', item);
    setSelectedMenu(item.key);
  };

  const menuToPage = {
    analytics_dashboard: <StatsDashboard />,
    center_analytics: <CenterAnalytics />,
    modalities_master: <ModalityMaster />,
    modality_groups: <ModalityGroups />,
    body_parts_master: <BodyPartsMaster />,
    item_codes: <ItemCodes />,
    modality_locations: <ModalityLocations />,
    hl7_routing: <Hl7ForwardRoutes />,
    manage_studies: <ManageStudies />,
    referral_physicians_list: <ReferralPhysicians />,
    nodes_list: <NodeList />,
    add_node: <AddNewNode />,
    users_list: <UserList />,
    add_user: <AddUser />,
    oo_templates_list: <TemplateListOodocs />,
    oo_add_template: <AddTemplateOodocs />,
    centers_list: <CenterList />,
    add_center: <AddCenter />,
    report_header_config: <ReportHeaderConfig />,
    shortcuts_admin: <ShortcutsAdmin />,
    session_management: <SessionManagement />,
    pricing_list: <PricingList />,
    add_pricing: <AddPricing />,
    cost_reports: <CostReports />,
    academics: <AcademicsPage />,
    hl7_logs_mwl: <IntegrationLogs key="MWL" logType="MWL" />,
    hl7_logs_oru: <IntegrationLogs key="ORU" logType="ORU" />,
  };

  return (
    <div className="settings-container h-100">
      <div className="d-flex h-100">
        <div className={`side-menu ${collapsed ? 'collapsed' : ''}`}>
          {/* <Tooltip title={collapsed ? 'Expand' : 'Collapse'}>
            <Button
              type="primary"
              className="toggle-btn"
              onClick={toggleCollapsed}
              style={{ marginBottom: 16 }}
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </Button>
          </Tooltip> */}
          <Menu
            defaultSelectedKeys={[selectedMenu]}
            defaultOpenKeys={['analytics', 'study_admin', 'users', 'masters', 'referral_physicians', 'oo_templates', 'centers', 'library', ...(window.ENV_CONFIG?.ENABLE_SESSION_TRACKING ? ['security'] : []), ...(window.ENV_CONFIG?.ENABLE_CENTRE_BILLING ? ['billing'] : [])]}
            mode="inline"
            inlineCollapsed={collapsed}
            items={NavigationItems(onNavChange, userType)}
            onClick={onNavChange}
          />
        </div>
        <div className="flex-1 content-area overflow-auto">
          {menuToPage[selectedMenu]}
        </div>
      </div>
    </div>
  );
};

export default Settings;
